import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const propTypes = {
    /** The name of the Inventory Tag */
    name: PropTypes.string.isRequired,

    /** The name of the icon within the Inventory Tag */
    tagIconName: PropTypes.node.isRequired,

    /** Class to define the color of the Inventory Tag */
    iconClass: PropTypes.string.isRequired,

    /** If true, the name of the inventory will be visible on the Inventory Tag */
    hasText: PropTypes.bool,

    /** If true, the Inventory Tag will be wrapped in a <span> instead of an <li> */
    isSpanItem: PropTypes.bool,

    /** Sets the size of the Inventory Tag */
    size: PropTypes.oneOf(['sm', 'md', 'lg']),

    /** Sets the size of the Inventory Tag */
    isInverse: PropTypes.bool,

    /** Added to existing classes */
    className: PropTypes.string
};

const defaultProps = {
    isSpanItem: false,
    hasText: false,
    isInverse: false,
    size: 'md',
    className: undefined
};

export default class BaseInventoryTag extends React.PureComponent {
    render() {
        const {
            name,
            tagIconName,
            iconClass,
            isSpanItem,
            size,
            className,
            isInverse,
            hasText
        } = this.props;

        const classes = cx('rec-inventory-tag', className, {
            'rec-inventory-tag-sm': size === 'sm',
            'rec-inventory-tag-md': size === 'md',
            'rec-inventory-tag-lg': size === 'lg',
            'rec-inventory-tag-is-inverse': isInverse
        });

        const InventoryTagWrapper = isSpanItem ? 'span' : 'li';

        const InventoryTagItem = () => (
            <InventoryTagWrapper
                className={cx(`${classes} rec-${iconClass}-tag${hasText ? '-has-text' : ''}`)}
                key={name}>
                    {tagIconName}
                    {hasText ? name : ''}
            </InventoryTagWrapper>
        );

        return (
            <InventoryTagItem
                name={name}
                icon={tagIconName}
                iconClass={iconClass}
                hasText={hasText}
                key={name} />
            );
        }
    }


BaseInventoryTag.propTypes = propTypes;
BaseInventoryTag.defaultProps = defaultProps;
